import React, { useState } from "react";
import toast, { Toaster } from "react-hot-toast";

const NewsletterButton: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter an email address");
      return;
    }
    
    setLoading(true);
    const toastId = toast.loading("Processing...");
    
    try {
      const response = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      
      if (response.ok) {
        toast.success("Successfully subscribed! You will shortly receive welcome mail ", { id: toastId });
        setEmail("");
      } else {
        toast.error(data.error || "Subscription failed", { id: toastId });
      }
    } catch (error) {
      toast.error("An error occurred. Please try again later.", { id: toastId });
    }
    
    setLoading(false);
  };

  return (
    <div className="newsletter-container">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#333",
            color: "#fff",
          },
        }}
      />
      <form className="newsletter-form" onSubmit={handleSubscribe}>
        <input
          type="email"
          placeholder="Enter your email"
          className="newsletter-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button type="submit" className="newsletter-button" disabled={loading}>
          {loading ? "Processing..." : "Subscribe"}
        </button>
      </form>
    </div>
  );
};

export default NewsletterButton;
